import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreEndpointsConstant } from '@constants/store-endpoints.constant';
import { EN_STRINGS } from '@constants/translations.constants';
import { DeviceLostOption } from '@models/dashboard.model';
import { HelpTextsInfo } from '@models/shopping.model';
import { UrlUtils } from '@utils/url.utils';
import { Observable } from 'rxjs';
import { dataLoaderContext } from 'tangoe-design-system';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: Map<string, string> = new Map<string, string>();

  constructor(private http: HttpClient, private url_utl: UrlUtils) {}

  getTranslations(): Observable<[[string, string]]> {
    return this.http.get<[[string, string]]>(StoreEndpointsConstant.TRANSLATIONS, {
      context: dataLoaderContext('global')
    });
  }

  setTranslations(translations: [[string, string]] | undefined): void {
    this.translations = new Map(translations);
  }

  translate(key: string, input?: string | string[] | undefined): string {
    let translation: string | undefined = this.translations.get(key);

    if (translation && input) return this.replaceTranslationInput(translation, input)!;

    return (
      translation ??
      this.replaceTranslationInput(EN_STRINGS[key], input) ??
      `TRANSLATION MISSING! key: ${key}`
    );
  }

  replaceTranslationInput(translation: string, input?: string | string[]): string | undefined {
    if (!translation) return undefined;

    if (typeof input === 'string') return translation.replace('${ input }', input);

    if (Array.isArray(input) && input.length > 0)
      for (let i in input) translation = translation.replace(`${'${ input_' + i} }`, input[i]);

    return translation;
  }

  getTranslatedDeviceSortValues(): string[] {
    return [
      this.translate('price_low_to_high'),
      this.translate('price_high_to_low'),
      this.translate('brand_a_to_z'),
      this.translate('brand_z_to_a'),
      this.translate('carrier_a_to_z'),
      this.translate('carrier_z_to_a')
    ];
  }

  getTranslatedAccessorySortValues(): string[] {
    return [
      this.translate('price_low_to_high'),
      this.translate('price_high_to_low'),
      this.translate('name_a_to_z'),
      this.translate('name_z_to_a')
    ];
  }

  getTranslatedSimOptionLabels(): string[] {
    return [
      this.translate('sim_option_label_own'),
      this.translate('sim_option_label_new'),
      this.translate('sim_option_label_esim')
    ];
  }

  getTranslatedDeviceUpgradeOptions(): DeviceLostOption[] {
    return [
      {
        id: 1,
        name: this.translate('keep_old_plans_and_features_yes')
      },
      {
        id: 2,
        name: this.translate('keep_old_plans_and_features_no')
      }
    ];
  }

  getTranslatedModalLabels(dashboard: boolean = false): string[] {
    return [
      this.translate('confirm_clear_cart_modal_title'),
      this.translate(
        dashboard ? 'confirm_clear_cart_modal_body_dashboard' : 'confirm_clear_cart_modal_body'
      )
    ];
  }

  getTranslatedHelpTexts(order_type_id: number): Observable<HelpTextsInfo> {
    return this.http.get<HelpTextsInfo>(StoreEndpointsConstant.GET_HELP_TEXTS, {
      params: { orderTypeId: order_type_id }
    });
  }
}
